/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Partner_Detail_Group_PeriodsInputs */



/**
* | output |
* | --- |
* | "{count} periods" |
*
* @param {Partner_Detail_Group_PeriodsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_detail_group_periods = /** @type {((inputs: Partner_Detail_Group_PeriodsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Detail_Group_PeriodsInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Zeiträume`)
	return /** @type {LocalizedString} */ (`${i?.count} periods`)
});